<template>
    <span></span>
</template>

<script>
export default {
  name: "TrustedDeviceMixin",
  data() {
    return {
      checkingTrustedDevice: false,
    }
  },
  methods: {
    async checkTrustedDevice() {
      // Check if user has a trusted device
      const hasTrustedDevice = localStorage.getItem('trusted_device') === 'true';
      
      if (hasTrustedDevice) {
        this.checkingTrustedDevice = true;
        try {
          // Validate trusted device with backend
          const response = await this.$api.user.validate_trusted_device();
          
          if (response && response.trusted) {
            // Device is trusted, try to get current user
            try {
              await this.$api.get_current_user();
              const currentUser = this.$store.getters['user/get_current_user'];
              
              if (currentUser) {
                // User is already logged in, redirect to projects
                this.$router.push('/projects');
                return;
              }
            } catch (error) {
              // Could not get current user, clear trusted device
              console.log('Could not get current user, clearing trusted device');
              localStorage.removeItem('token');
              localStorage.removeItem('token_expired_on');
              localStorage.removeItem('trusted_device');
              // Don't redirect here, let the user stay on login page
              return;
            }
          } else {
            // Device is not trusted or expired, clear local storage
            console.log('Device not trusted or expired:', response && response.message);
            localStorage.removeItem('token');
            localStorage.removeItem('token_expired_on');
            localStorage.removeItem('trusted_device');
          }
        } catch (error) {
          // Error validating trusted device, clear local storage
          console.log('Error validating trusted device:', error);
          localStorage.removeItem('token');
          localStorage.removeItem('token_expired_on');
          localStorage.removeItem('trusted_device');
          // Don't redirect here, let the user stay on login page
        } finally {
          this.checkingTrustedDevice = false;
        }
      }
    },
  }
}
</script>

<style scoped>

</style> 